// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { error } from 'react-notification-system-redux'
import { UNCAUGHT_ERROR } from 'errors'

const handleError = (uid, message) => dispatch => {
  const errorUID = `${uid}-error`

  dispatch(error({
    uid: errorUID,
    title: 'Error! The following error was returned:',
    autoDismiss: 0,
    children: (
      <span id={errorUID}>
        {`Error: ${message}` || UNCAUGHT_ERROR}
      </span>
    ),
  }))
}

export default handleError
